import React, { FC } from 'react';
import { Route, generatePath } from 'react-router-dom';
import DashboardWrap from '../../../components/DashboardWrap';
import { AdminRouteName } from '../../CONSTANTS';
// import RolesAndPermissionGuard from '../../../components/RolesAndPermissionGuard';
import ProductAnalysisDistribution from './ProductAnalysisDistribution';
import ProductAnalysisTrends from './ProductAnalysisTrends';
import DashboardHeader from '../../../components/DashboardHeader';
import CustomerTabs from '../CustomerTabs';
import './productAnalysis.scss';
import RolesAndPermissionGuard from '../../../components/RolesAndPermissionGuard';
import PermissionDenied from '../../PermissionDenied';

const ProductAnalysis: FC = () => {
  const tabs = [
    {
      name: 'Product distribution', link: AdminRouteName.customerProductAnalysisRoute,
    },
    {
      name: 'Trends over time', link: generatePath(AdminRouteName.customerProductAnalysisTendRoute),
    },
  ];
  return (
    <DashboardWrap>
      {/* <RolesAndPermissionGuard permissionName=""> */}
      <DashboardHeader
        title="Customers"
      >
        <CustomerTabs Tabs={tabs} />
      </DashboardHeader>
      <div className="product-analysis-root">
        <Route
          // component={}
          path={AdminRouteName.customerProductAnalysisRoute}
          exact
        >
          <RolesAndPermissionGuard permissionName="can-view-product-analysis" hasErrorTemplate={<PermissionDenied height="70vh" />}>
            <ProductAnalysisDistribution />
          </RolesAndPermissionGuard>
        </Route>
        <Route
          path={AdminRouteName.customerProductAnalysisTendRoute}
          exact
        >
          <RolesAndPermissionGuard permissionName="can-view-product-analysis" hasErrorTemplate={<PermissionDenied height="70vh" />}>
            <ProductAnalysisTrends />

          </RolesAndPermissionGuard>

        </Route>
      </div>
      {/* </RolesAndPermissionGuard> */}
    </DashboardWrap>
  );
};

export default ProductAnalysis;
